import React from 'react'
import PropTypes from 'prop-types'
import Style from './style'
import { range, getMonthNameFull, getWeekDayName } from '../../helpers'

const defaultList = []

class DatePicker extends React.Component {
  constructor (props) {
    super(props)
    props = Object.assign({}, props)
    const allDayInWeek = range(4, 11, 1)
    this.dayInWeek = allDayInWeek.map((day) => {
      return getWeekDayName(new Date(1970, 0, day), props.language)
    })
    const allMonth = range(0, 12, 1)
    this.monthInYear = allMonth.map((month) => {
      return getMonthNameFull(new Date(1970, month, 1), props.language)
    })
    props.selectDate = props.selectDate != null ? props.selectDate : new Date()
    this.weekend = props.weekend ? props.weekend : defaultList
    const startOfMonth = new Date(props.selectDate.getFullYear(), props.selectDate.getMonth(), 1)
    if (props.startSelectable != null) {
      this.startSelectableYear = new Date(props.startSelectable.getFullYear(), 0, 1)
      this.startSelectableMonth = new Date(props.startSelectable.getFullYear(), props.startSelectable.getMonth(), 1)
      this.startSelectableDate = new Date(props.startSelectable.getFullYear(), props.startSelectable.getMonth(), props.startSelectable.getDate())
    }

    if (props.endSelectable != null) {
      this.endSelectableYear = new Date(props.endSelectable.getFullYear(), 0, 1)
      this.endSelectableMonth = new Date(props.endSelectable.getFullYear(), props.endSelectable.getMonth(), 1)
      this.endSelectableDate = new Date(props.endSelectable.getFullYear(), props.endSelectable.getMonth(), props.endSelectable.getDate())
    }

    this.oneDay = 24 * 60 * 60 * 1000
    this.oneMonth = 30 * this.oneDay
    this.oneYear = 12 * this.oneMonth
    this.state = {
      isShowingDate: true,
      isShowingMonth: false,
      isShowingYear: false,
      doReRender: false,
      selectDate: props.selectDate ? props.selectDate.getDate() : null,
      startDay: props.selectDate ? startOfMonth.getDay() : null,
      selectMonth: props.selectDate ? props.selectDate.getMonth() : null,
      selectYear: props.selectDate ? props.selectDate.getFullYear() : null
    }
  }

  validateData () {
    if (this.state.selectDate == null) return false
    if (this.state.selectMonth == null) return false
    if (this.state.selectYear == null) return false
    return true
  }

  handleDateSelect (event, date) {
    this.setState({
      selectDate: date
    })
  }

  handleMonthSelect (event, index) {
    const { getHolidays } = this.props
    let newDate = new Date(this.state.selectYear, index, 1)
    const totalDayInMonth = this.getTotalDayInMonth(index, this.state.selectYear)
    let selectDate = this.state.selectDate
    if (this.state.selectDate >= totalDayInMonth) selectDate = totalDayInMonth
    newDate = new Date(this.state.selectYear, index, selectDate)
    if (newDate < this.startSelectableDate) {
      newDate = new Date(this.state.selectYear, this.startSelectableDate.getMonth(), this.startSelectableDate.getDate())
    } else if (newDate > this.endSelectableDate) {
      newDate = new Date(this.state.selectYear, this.endSelectableDate.getMonth(), this.endSelectableDate.getDate())
    }
    const year = newDate.getFullYear()
    const month = newDate.getMonth()
    const date = newDate.getDate()
    const startOfMonth = new Date(year, month, 1)
    this.setState({
      isShowingMonth: false,
      isShowingYear: false,
      selectMonth: month,
      startDay: startOfMonth.getDay(),
      selectDate: date,
      doReRender: !this.state.doReRender
    }, () => {
      const countDay = new Date(year, month + 1, 0)
      getHolidays({ year, month, countDay: countDay.getDate() })
    })
  }

  handleYearSelect (event, year) {
    const { getHolidays } = this.props
    let newDate = new Date(year, this.state.selectMonth, 1)
    const totalDayInMonth = this.getTotalDayInMonth(this.state.selectMonth, year)
    let selectDate = this.state.selectDate
    if (this.state.selectDate >= totalDayInMonth) selectDate = totalDayInMonth
    newDate = new Date(year, this.state.selectMonth, selectDate)
    if (newDate < this.startSelectableDate) {
      newDate = new Date(year, this.startSelectableDate.getMonth(), this.startSelectableDate.getDate())
    } else if (newDate > this.endSelectableDate) {
      newDate = new Date(year, this.endSelectableDate.getMonth(), this.endSelectableDate.getDate())
    }
    year = newDate.getFullYear()
    const month = newDate.getMonth()
    const date = newDate.getDate()
    const startOfMonth = new Date(year, month, 1)
    this.setState({
      isShowingMonth: false,
      isShowingYear: false,
      selectYear: year,
      startDay: startOfMonth.getDay(),
      selectMonth: month,
      selectDate: date,
      doReRender: !this.state.doReRender
    }, () => {
      const countDay = new Date(year, month + 1, 0)
      getHolidays({ year, month, countDay: countDay.getDate() })
    })
  }

  getTotalDayInMonth (month = (new Date()).getMonth(), year = (new Date()).getFullYear()) {
    return 32 - (new Date(year, month, 32)).getDate()
  }

  getMonth (disabledList = defaultList, today = new Date()) {
    const selectYear = this.state.selectYear
    const selectMonth = this.state.selectMonth
    const todayMonth = today.getMonth()
    return this.monthInYear.map((month, index) => {
      let className = 'currentCar'
      let disabled = null
      const monthObject = new Date(selectYear, index, 1)
      if (this.startSelectableMonth != null && monthObject < this.startSelectableMonth) {
        disabled = true
      } else if (this.endSelectableMonth != null && monthObject > this.endSelectableMonth) {
        disabled = true
      } else if (disabledList.includes(month)) disabled = true
      if (index === todayMonth) className = className.concat(' today')
      if (index === selectMonth) className = className.concat(' selectDate')
      return (
        <button
          key={month}
          className={className}
          disabled={disabled}
          onClick={(event) => { this.handleMonthSelect(event, index) }}
        >
          <h3>{month}</h3>
        </button>
      )
    })
  }

  getYear (disabledList = defaultList, startYear = null, endYear = null, today = new Date()) {
    const result = []
    const selectYear = this.state.selectYear
    const todayYear = today.getFullYear()
    if (startYear == null) startYear = (selectYear != null ? selectYear : todayYear) - 10
    if (endYear == null) endYear = (selectYear != null ? selectYear : todayYear) + 10

    for (let year = startYear; year <= endYear; year++) {
      let disabled = null
      let className = 'currentCar'
      const yearObject = new Date(year, 0, 1)
      if (this.startSelectableYear != null && yearObject < this.startSelectableYear) {
        disabled = true
      } else if (this.endSelectableYear != null && yearObject > this.endSelectableYear) {
        disabled = true
      } else if (disabledList.includes(year)) disabled = true
      if (year === todayYear) className = className.concat(' today')
      if (year === selectYear) className = className.concat(' selectDate')
      result.push(
        <button
          key={year}
          className={className}
          disabled={disabled}
          onClick={(event) => { this.handleYearSelect(event, year) }}
        >
          <h3>{year}</h3>
        </button>
      )
    }
    return result
  }

  getCalendar (startDayInWeek = 0, disabledList = defaultList, today = new Date()) {
    const {
      listHoliday
    } = this.props
    const selectDate = this.state.selectDate ? this.state.selectDate : today.getDate()
    const selectMonth = this.state.selectMonth
    const selectYear = this.state.selectYear
    const weekend = this.weekend
    today = new Date(today.getFullYear(), today.getMonth(), today.getDate())
    const todayMonth = new Date(today.getFullYear(), today.getMonth(), 1)
    const lastDayOfThisMonth = this.getTotalDayInMonth(selectMonth != null ? selectMonth : todayMonth.getMonth(), selectYear != null ? selectYear : todayMonth.getFullYear())
    const lastMonth = new Date(selectYear != null ? selectYear : todayMonth.getFullYear(), selectMonth != null ? selectMonth - 1 : todayMonth.getMonth() - 1, 1)
    const lastDayOfPreMonth = this.getTotalDayInMonth(lastMonth.getMonth(), lastMonth.getFullYear())
    let startDay = this.state.startDay != null ? this.state.startDay : todayMonth.getDay()
    if (startDay > startDayInWeek) {
      startDay = startDay - startDayInWeek
    } else if (startDay < startDayInWeek) {
      startDay = startDay + 7 - startDayInWeek
    }
    const result = []
    for (let i = lastDayOfPreMonth - (startDay - 1); i <= lastDayOfPreMonth; i++) {
      result.push(<button key={'prev' + i} className='prevCar' disabled><h3>{i}</h3></button>)
    }

    for (let i = 1; i < selectDate; i++) {
      let disabled = null
      let className = 'currentCar'

      const dateObject = new Date(selectYear, selectMonth, i)
      if (this.startSelectableDate != null && dateObject < this.startSelectableDate) {
        disabled = true
      } else if (this.endSelectableDate != null && dateObject > this.endSelectableDate) {
        disabled = true
      } else if (disabledList.includes(i)) {
        disabled = true
      } else if (weekend.includes((startDay + i - 1 + startDayInWeek) % 7)) {
        disabled = true
      }
      if (today.valueOf() === new Date(selectYear, selectMonth, i).valueOf())className = className.concat(' today')
      className = className.concat(' ' + this.dayInWeek[(i + startDay - 1 + startDayInWeek) % 7])
      const holiday = listHoliday.find(e => new Date(e.date).getDate() === i)
      result.push(<button key={'curr' + i} disabled={disabled} className={holiday ? className + ' holiday' : className} onClick={(event) => { this.handleDateSelect(event, i) }}><h3>{i}</h3></button>)
    }

    let disabled = null
    let className = 'currentCar'
    const dateObject = new Date(selectYear, selectMonth, selectDate)
    if (this.startSelectableDate != null && dateObject < this.startSelectableDate) {
      disabled = true
    } else if (this.endSelectableDate != null && dateObject > this.endSelectableDate) {
      disabled = true
    } else if (disabledList.includes(selectDate)) {
      disabled = true
    } else if (weekend.includes((startDay + selectDate - 1 + startDayInWeek) % 7)) {
      disabled = true
    }

    if (today.valueOf() === new Date(selectYear, selectMonth, selectDate).valueOf()) className = className.concat(' today')
    className = className.concat(' selectDate')
    className = className.concat(' ' + this.dayInWeek[(selectDate + startDay - 1 + startDayInWeek) % 7])
    const holiday = listHoliday.find(e => new Date(e.date).getDate() === selectDate)
    result.push(<button key={'curr' + selectDate} disabled={disabled} className={holiday ? className + ' holiday' : className}><h3>{selectDate}</h3></button>)

    for (let i = selectDate + 1; i <= lastDayOfThisMonth; i++) {
      let disabled = null
      let className = 'currentCar'

      const dateObject = new Date(selectYear, selectMonth, i)
      if (this.startSelectableDate != null && dateObject < this.startSelectableDate) {
        disabled = true
      } else if (this.endSelectableDate != null && dateObject > this.endSelectableDate) {
        disabled = true
      } else if (disabledList.includes(i)) {
        disabled = true
      } else if (weekend.includes((startDay + i - 1 + startDayInWeek) % 7)) {
        disabled = true
      }

      if (today.valueOf() === new Date(selectYear, selectMonth, i).valueOf()) className = className.concat(' today')
      className = className.concat(' ' + this.dayInWeek[(i + startDay - 1 + startDayInWeek) % 7])
      const holiday = listHoliday.find(e => new Date(e.date).getDate() === i)
      result.push(
        <button
          key={'curr' + i}
          disabled={disabled}
          className={holiday ? className + ' holiday' : className}
          onClick={(event) => {
            this.handleDateSelect(event, i)
          }}
        >
          <h3>{i}</h3>
        </button>
      )
    }
    for (let i = 1; i <= 42 - (lastDayOfThisMonth + startDay); i++) {
      result.push(<button key={'next' + i} className='nextCar' disabled><h3>{i}</h3></button>)
    }

    return result
  }

  getCalendarHeader (startDayInWeek = 0) {
    if (startDayInWeek == null) startDayInWeek = 0
    const dayInWeek = this.dayInWeek.slice(startDayInWeek).concat(this.dayInWeek.slice(0, startDayInWeek))
    return dayInWeek.map((day) => <h4 key={day} className='calendarHeader'>{day}</h4>)
  }

  toggleMonthView () {
    this.setState({
      isShowingMonth: !this.state.isShowingMonth,
      isShowingYear: false
    })
  }

  toggleYearView () {
    this.setState({
      isShowingYear: !this.state.isShowingYear,
      isShowingMonth: false
    })
  }

  render () {
    const props = Object.assign({}, this.props)
    const validationResult = this.validateData()
    const month = this.state.selectMonth != null ? this.state.selectMonth : new Date().getMonth()
    const year = this.state.selectYear != null ? this.state.selectYear : new Date().getFullYear()
    return (
      <Style colorTheme={props.colorTheme}>
        <section className='DatePicker jump-in'>
          <section className='MonthnYear'>
            <button onClick={() => this.toggleMonthView()}><h1>{this.monthInYear[month]}</h1></button>
            <button onClick={() => this.toggleYearView()}><h1>{year}</h1></button>
          </section>
          <hr />
          <section className='calendarField'>
            <section className={
              'calendarDay ' + ((this.state.isShowingMonth || this.state.isShowingYear) ? 'fade-out' : 'fade-in')
            }
            >
              {this.getCalendarHeader(props.startDay ? props.startDay : 0)}
              {this.getCalendar(
                props.startDay ? props.startDay : 0,
                (props.disabledDate &&
                props.disabledDate[year] &&
                props.disabledDate[year][month]) ? props.disabledDate[year][month] : defaultList)}
            </section>
            {this.state.isShowingMonth
              ? <section className='calendarMonth slide-in' isshowing={Boolean(this.state.isShowingMonth).toString()}>
                {this.getMonth((props.disabledMonth && props.disabledMonth[year]) ? props.disabledMonth[year] : defaultList)}
              </section>
              : null}
            {this.state.isShowingYear
              ? <section className='calendarYear slide-in' isshowing={Boolean(this.state.isShowingYear).toString()}>
                {this.getYear(props.disabledYear ? props.disabledYear : defaultList, props.startYear, props.endYear)}
              </section>
              : null}
          </section>
          <hr className='lightLine' />
          <section className='calendarButton'>
            <button className='closeButton' onClick={(event) => props.handleCloseButton(event)}><h3>{props.language === 'TH' ? 'กลับ' : 'Close'}</h3></button>
            <button disabled={!validationResult} className='saveButton' onClick={validationResult ? (event) => props.handleSaveButton(event, new Date(this.state.selectYear, this.state.selectMonth, this.state.selectDate)) : () => {}}><h3>{props.language === 'TH' ? 'บันทึก' : 'Save'}</h3></button>
          </section>
        </section>
      </Style>
    )
  }
}

DatePicker.propTypes = {
  selectDate: PropTypes.instanceOf(Date),
  startSelectable: PropTypes.instanceOf(Date),
  endSelectable: PropTypes.instanceOf(Date),
  startDay: PropTypes.number,
  startYear: PropTypes.number,
  endYear: PropTypes.number,
  disabledDate: PropTypes.array,
  disabledMonth: PropTypes.shape(),
  disabledYear: PropTypes.shape(),
  handleSaveButton: PropTypes.func.isRequired,
  handleCloseButton: PropTypes.func.isRequired,
  isShowing: PropTypes.bool
}

export default DatePicker
